export function Calendar(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="24"
        height="21"
        viewBox="0 0 24 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.00005 9H6.00005C5.44776 9 5.00005 9.44771 5.00005 10V12C5.00005 12.5523 5.44776 13 6.00005 13H8.00005C8.55233 13 9.00005 12.5523 9.00005 12V10C9.00005 9.44771 8.55233 9 8.00005 9Z"
          fill="currentColor"
        />
        <path
          d="M11 9H13C13.5523 9 14 9.44771 14 10V12C14 12.5523 13.5523 13 13 13H11C10.4478 13 10 12.5523 10 12V10C10 9.44771 10.4478 9 11 9Z"
          fill="currentColor"
        />
        <path
          d="M18 9H16C15.4478 9 15 9.44771 15 10V12C15 12.5523 15.4478 13 16 13H18C18.5523 13 19 12.5523 19 12V10C19 9.44771 18.5523 9 18 9Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.50005 0C8.32848 0 9.00005 0.671573 9.00005 1.5V1.8H15V1.5C15 0.671573 15.6716 0 16.5 0C17.3285 0 18 0.671573 18 1.5V1.8H20C21.7674 1.8 23.2 3.23269 23.2 5V17C23.2 18.7673 21.7674 20.2 20 20.2H4.00005C2.23274 20.2 0.800049 18.7673 0.800049 17V5C0.800049 3.23269 2.23274 1.8 4.00005 1.8H6.00005V1.5C6.00005 0.671573 6.67162 0 7.50005 0ZM15 4.2V4.5C15 5.32843 15.6716 6 16.5 6C17.3285 6 18 5.32843 18 4.5V4.2H20C20.4419 4.2 20.8 4.55817 20.8 5V17C20.8 17.4418 20.4419 17.8 20 17.8H4.00005C3.55822 17.8 3.20005 17.4418 3.20005 17V5C3.20005 4.55817 3.55822 4.2 4.00005 4.2H6.00005V4.5C6.00005 5.32843 6.67162 6 7.50005 6C8.32848 6 9.00005 5.32843 9.00005 4.5V4.2H15Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
